import React, { useState, useEffect, Fragment } from 'react';
import localization from 'assets/localization/localization';
import { handleValidateObj } from 'constants/objValues/objvalues';

const Input = ({ el, item, onHandle, className }) => {
  const checklist = {
    id: '',
    answer: '',
    is_required: '',
    question_id:''
  };
  const [formData, setformData] = useState(checklist);
  const [errorFlag, setErrorFlag] = useState(true);
  const [isTrue, setIsTrue] = useState(false);

  useEffect(() => {
    const isNotEmpty = Object.values(formData).length > 0;
    // const isNotEmpty = handleValidateObj(formData);
    if (isNotEmpty !== false) {
      onHandle(formData);
      setErrorFlag(false);
    } else {
      setErrorFlag(true);
    }
  }, [formData, onHandle]);

  useEffect(() => {
    setformData({});
  }, [isTrue]);

  return (
    <div className="sub-question radio-wrapper">
      <label className="label">
        {/* {el && el.label} */}
       {el && el.is_q_required ? (
                                  <span style={{ color: 'red' }}>
                                    <span style={{ color: 'black' }}>{el.label}</span> * </span>
                                ):<span>{el.label} </span> }</label>
      {el &&
        el.options.map((value, no) => {
          return (
            <>
              <span key={no}>
                <input
                  type="radio"
                  name={el.id}
                  className={(el.is_q_required==1 && errorFlag)?"activeAnkInput":""}
                  required={(el.is_q_required==1)?true:false}
                  errorMsg={localization.questionRequired}
                  value={value}
                  checked={formData.answer === value}
                  onChange={(e) =>
                    setformData({
                      ...formData,
                      answer: e.target.value,
                      id: el.id,
                      is_required: (el.is_q_required==1)?true:false,
                      question_id: item?.question_id
                    })
                  }
                />
                <span className="btn btn-primary btn-sm">{value}</span>
              </span>
            </>
          );
        })}
      <label
        className={`error ${
          el.is_q_required && errorFlag && className ? `d-block` : ''
        }`}
      >
        {localization.questionRequired}
      </label>
      {!!Object.values(formData).length && (
        <button
          style={{ border: 'transparent' }}
          className="field-remove"
          onClick={() => setIsTrue(!isTrue)}
        >
          Clear
        </button>
      )}
    </div>
  );
};

export default Input;
